<template>
    <left-side-filters
        v-if="true"
        class="promo"
        :filters="filters"
        module-name="promotions"
        :show-user-filters="true"
        @apply-filters="applyFilters"
    >
        <template #header>
            <ui-slider
                v-if="topBanner"
                class="promo__banner"
                :content="topBanner"
            />
            <section-header
                title="Promocje"
                sub-title="Zarządzaj promocjami udostępnionymi przez Organizatora Sieci oraz zakładaj własne"
                class="mb-3 mb-lg-4"
            />
            <div
                class="d-flex align-items-center justify-content-between gap-1"
            >
                <header-tabs
                    class="mt-3 mt-lg-4"
                    style="flex: 1"
                    :content="headerTabs"
                    @changeTab="changeTab"
                />

                <div class="d-none d-lg-flex gap-0-5 header-buttons">
                    <the-btn
                        v-if="isProductEansPermission"
                        class="btn-sm btn-secondary"
                        @click.native="$router.push({ name: 'product-eans' })"
                        text="Kody lokalne"
                    />
                    <the-btn
                        v-if="isOwnPromoPermission"
                        class="btn-sm btn-secondary"
                        id="add-new-promo-btn"
                        @click.native="$router.push({ name: 'add-new-promo' })"
                        text="Dodaj nową promocję"
                    />
                </div>
            </div>
        </template>

        <template #after-filters>
            <ui-slider
                v-if="leftBanner"
                class="promo__leftBanner"
                :content="leftBanner"
            />
        </template>

        <template #content>
            <div class="d-flex d-lg-none gap-1">
                <the-btn
                    v-if="isProductEansPermission"
                    class="ml-auto btn-secondary mt-md-4 mt-0 mb-4"
                    @click.native="$router.push({ name: 'product-eans' })"
                    text="Kody lokalne"
                />

                <the-btn
                    v-if="isOwnPromoPermission"
                    class="btn-secondary mt-md-4 mt-0 mb-4"
                    id="add-new-promo-btn"
                    @click.native="$router.push({ name: 'add-new-promo' })"
                    text="Dodaj nową promocję"
                />
            </div>

            <div class="c-promos-settings d-flex flex-column">
                <div class="c-settings pt-2">
                    <div
                        v-if="
                            pagination.totalRecords &&
                                promoGroupsStatus === 'idle'
                        "
                        class="c-settings-count"
                    >
                        {{
                            pagination.totalRecords
                                | plurals('wynik', 'wyniki', 'wyników')
                        }}
                    </div>
                    <div class="c-settings-filters mt-2 mt-md-0 ml-auto">
                        <div class="d-block ml-3">
                            <results-per-page
                                text="Pokazuj na stronie:"
                                :per-page="pagination.perPage"
                                :on-change="changeResultsPerPage"
                                :options="[5, 10, 25]"
                            />
                        </div>
                        <div class="d-block ml-3">
                            <sort-component
                                text="Sortuj po:"
                                module-name="promoGroups"
                                :options="
                                    $store.getters.getPromoGroupsSortOptions
                                "
                                @onChange="fetch"
                            />
                        </div>
                    </div>
                </div>
                <selected-filters
                    class="mb-4"
                    module-name="promotions"
                    :filters="filters"
                    @applyFilters="applyFilters"
                />
                <div
                    class="
                        d-flex align-items-end justify-content-end
                        c-promos-info gap-0-5 flex-wrap
                    "
                >
                    <active-promos-btn
                        v-if="isActivePromosTab"
                        :filters="filters"
                        :disabled="isLotteryUser || !promoGroups?.length"
                        class="justify-self-end"
                        id="download-active-promos-btn"
                    />
                    <button
                        v-if="isActivePromosTab"
                        @click="exportPromotions"
                        :disabled="isLotteryUser"
                        class="btn btn-secondary justify-self-end"
                        id="export-promos-btn"
                    >
                        Eksport promocji do pliku
                    </button>
                    <div
                        v-if="
                            isPromoEditPermission &&
                                ($route.name === 'promo-list' ||
                                    $route.name === 'promo-later')
                        "
                        class="c-promos-refundInfo flex-grow-1 text-sm a-infoBar a-infoBar--warning"
                    >
                        Decyzja o cenie w Promocji należy do Ciebie - aktywuj
                        wybrane promocje i edytuj ich cenę w oknie aktywacji.
                        Tylko cena ustalona przez Ciebie na poziomie nie wyższym
                        niż zaproponowana uprawnia do otrzymania Zwrotu Kosztów.
                    </div>
                </div>
            </div>

            <!-- Promotions list -->
            <div class="content">
                <page-preloader v-if="promoGroupsStatus === 'loading'" />
                <promo-groups
                    v-else-if="promoGroups && promoGroups.length"
                    :groups="promoGroups"
                    :preview-type="$route.name"
                    class="mb-5 mt-4"
                />
                <div class="mt-4 mb-5" v-else>
                    Brak
                    {{ isNewPromos ? 'nowych promocji' : 'wyników' }}

                    <div v-if="promosCountInOtherTabs.length > 0">
                        Sprawdź

                        <span
                            v-for="(tab, tabIdx) in promosCountInOtherTabs"
                            :key="'tab-' + tabIdx"
                        ><!--
                            --><router-link
                                class="text-orange"
                                :to="{ name: tab.name }"
                            >
                                {{ tab.label }}<!--
                            --></router-link><!--
                            -->{{
                                `${
                                    promosCountInOtherTabs.length - 1 > tabIdx
                                        ? ', '
                                        : ''
                                }`
                            }}
                        </span>
                    </div>
                </div>

                <div class="d-flex align-items-center justify-content-between">
                    <the-pagination
                        v-if="pagination && +pagination.totalRecords > 0"
                        :pagination="pagination"
                        @change="onChange"
                    />
                    <results-per-page
                        text="Pokazuj na stronie:"
                        :per-page="pagination.perPage"
                        :on-change="changeResultsPerPage"
                        :options="[5, 10, 25]"
                    />
                </div>

                <ui-slider
                    v-if="bottomBanner"
                    class="promo__leftBanner"
                    :content="bottomBanner"
                />
            </div>
        </template>

        <template #selected-bar>
            <selected-promos
                v-if="selectedPromoGroups.length > 0"
                :selected-groups="selectedPromoGroups"
            />
        </template>
    </left-side-filters>
</template>

<script>
import LeftSideFilters from '@/components/layout/LeftSideFilters'
import PromoGroups from '@/components/promotions/PromoGroups'
import SelectedPromos from '@/components/promotions/SelectedPromos'
import ActivePromosBtn from '@/components/promotions/ActivePromosBtn'

export default {
    data() {
        return {
            isActivePromosTab: false,
            exportStatus: 'idle',
            activePromosStatus: 'idle'
        }
    },
    components: {
        LeftSideFilters,
        PromoGroups,
        SelectedPromos,
        ActivePromosBtn
    },
    computed: {
        topBanner() {
            return this.$store.getters.getTopBanner
        },
        leftBanner() {
            return this.$store.getters.getLeftBanner
        },
        bottomBanner() {
            return this.$store.getters.getBottomBanner
        },
        pagination() {
            return this.$store.getters.getPromoGroupsPagination
        },
        promoGroups() {
            return this.$store.getters.getPromoGroups
        },
        promoGroupsStatus() {
            return this.$store.getters.getPromoGroupsStatus
        },
        selectedPromoGroups() {
            return this.$store.getters.getSelectedPromoGroups
        },
        filters() {
            return this.$store.getters.getPromotionsFiltersByRoute(
                this.$route.name
            )
        },
        isNewPromos() {
            return this.filters.newPromos.value
        },
        isLotteryUser() {
            return this.$store.getters.isLotteryUser
        },
        isPromoEditPermission() {
            return this.$store.getters.isPromoEditPermission
        },
        isOwnPromoPermission() {
            return this.$store.getters.isOwnPromoPermission
        },
        isProductEansPermission() {
            return this.$store.getters.isProductEansPermission
        },
        filterNip() {
            return this.filters['promo|subscription|merchant|nip'].value
        },
        filterSelectedMerchants() {
            return this.filters['promo|subscription|merchant_id'].value
        },
        promotionsCount() {
            return this.$store.getters.getPromotionsCount
        },
        arePromoFiltersApplied() {
            return this.$store.getters.arePromoFiltersApplied(
                'getPromotionsFilters'
            )
        },
        promosCountInOtherTabs() {
            const routes = []

            for (const tab of this.headerTabs) {
                if (tab.linkName === this.$route.name) {
                    continue
                }

                if (tab.counter) {
                    routes.push({
                        label: (tab.textShort || tab.text) + ` (${tab.counter})`,
                        name: tab.route.name
                    })
                }
            }

            return routes
        },
        headerTabs() {
            const count = this.promotionsCount

            return [
                {
                    text: 'Dostępne promocje',
                    textShort: 'Dostępne',
                    counter: this.arePromoFiltersApplied
                        ? count['promo-list']
                        : undefined,
                    route: {
                        name: 'promo-list'
                    }
                },
                {
                    text: 'Aktywne promocje',
                    textShort: 'Aktywne',
                    counter: this.arePromoFiltersApplied
                        ? count['promo-yours']
                        : undefined,
                    route: {
                        name: 'promo-yours'
                    }
                },
                {
                    text: 'Zapisane na później',
                    textShort: 'Zapisane',
                    route: {
                        name: 'promo-later'
                    }
                },
                {
                    text: 'Archiwalne',
                    counter: this.arePromoFiltersApplied
                        ? count['promo-finished']
                        : undefined,
                    route: {
                        name: 'promo-finished'
                    }
                }
            ]
        }
    },
    watch: {
        filterSelectedMerchants() {
            for (const merchant of this.$store.getters.getAvailableMerchants) {
                for (const group of this.selectedPromoGroups) {
                    this.$store.dispatch('selectGroupMerchant', {
                        groupId: group.id,
                        merchantId: merchant.id,
                        value:
                            !this.filterSelectedMerchants.length ||
                            this.filterSelectedMerchants.includes(merchant.id)
                    })
                }
            }
        },
        $route: {
            handler: function(route) {
                if (route.name === 'promo-yours') {
                    this.isActivePromosTab = true
                } else {
                    this.isActivePromosTab = false
                    if (route.name === 'promo-finished') {
                        this.$store.dispatch('fetchAllCompaniesData')
                    }
                }
            },
            deep: true,
            immediate: true
        },
        filterNip: {
            handler: function(newVal, oldVal) {
                if (!newVal.length) return
                const filterMerchants = this.filters[
                    'promo|subscription|merchant_id'
                ].value
                const merchants = this.$store.getters.getMerchants
                const selectedMerchants = merchants.filter(merchant => {
                    return (
                        filterMerchants.includes(merchant.id) &&
                        newVal.includes(merchant.nip)
                    )
                })
                const merchantsToSelect = selectedMerchants
                    .filter(merchant => newVal.includes(merchant.nip))
                    .map(merchant => merchant.id)
                this.$store.dispatch('setFilter', {
                    filter: 'promo|subscription|merchant_id',
                    value: merchantsToSelect,
                    moduleName: 'promotions'
                })
            },
            deep: true
        }
    },
    beforeCreate() {
        const { $store } = this
        if ($store.getters.isShopUser) {
            $store.dispatch('userDataFetch')
        }
        $store.dispatch('setDefaultSortOption')
        $store.dispatch('setPromotionsFilters')
        $store.dispatch('setPromotionsDefaultPerPage')

        $store.dispatch('snippetsLoad', {
            code: 'snippet001',
            moduleName: 'advertisements'
        })
        $store.dispatch('snippetsLoad', {
            code: 'snippet002',
            moduleName: 'advertisements'
        })
        $store.dispatch('snippetsLoad', {
            code: 'snippet003',
            moduleName: 'advertisements'
        })
    },
    created() {
        const { $store } = this
        $store.dispatch('setPromoGroupsPagination', { page: 1 })

        this.setDynamicPromoFilters()
        window.scrollTo(0, 0)

        if (!$store.getUserFiltersInit) {
            $store.dispatch('loadUserFilters')
            $store.commit('SET_USER_FILTERS_INIT_LOAD', true)
        }

        if (!$store.getFavoritesInitLoad) {
            $store.dispatch('loadFavoritePromos')
            $store.commit('SET_FAVORITES_INIT_LOAD', true)
        }

        this.fetch()
    },
    beforeDestroy() {
        if (!this.isLotteryUser) {
            this.$store.dispatch('resetPromotions')
        }
    },
    methods: {
        setDynamicPromoFilters() {
            this.$store.dispatch('setDynamicPromoFilters')
        },
        async fetch() {
            const { $store } = this

            await $store.dispatch('loadPromoGroups')
            const expandedGroup = await $store.$storage.getItem('expandedGroup')

            if (expandedGroup) {
                return setTimeout(() => {
                    this.scrollToExpandedGroup()
                }, 0)
            }

            if (this.promotionsStatus === 'idle' && $store.getters.getScrollY) {
                this.$scrollTo('body', 400, {
                    offset: $store.getters.getScrollY
                })
                $store.dispatch('setScrollY', null)
            }
        },
        async scrollToExpandedGroup() {
            const expandedGroup = await this.$store.$storage.getItem(
                'expandedGroup'
            )
            if (expandedGroup) {
                const group = this.promoGroups.find(
                    group => group.id === expandedGroup.groupId
                )
                if (group) {
                    const offset = document.querySelector(
                        '.site-header__container'
                    ).offsetHeight

                    const scrollToElement = document.querySelector(
                        `[promo_id="${+expandedGroup.promoId}"][promo_group_id="${+expandedGroup.groupId}"]`
                    )
                    this.$scrollTo(scrollToElement, 400, {
                        offset: -offset - 20
                    })
                    this.$store.$storage.removeItem('expandedGroup')
                } else {
                    this.$store.$storage.removeItem('expandedGroup')
                }
            }
        },
        onChange(page) {
            this.$router.push({
                query: { ...this.$route.query, page }
            })
        },
        changeResultsPerPage(value) {
            return this.$router.push({
                query: { ...this.$route.query, show: value, page: 1 }
            })
        },
        async applyFilters() {
            this.$store.commit('SET_SELECTED_GROUPS_SELECTWHOLEGROUP', false)
            this.$store.commit('RESET_PROMOGROUPS_COUNT')
            await this.$store.dispatch('loadPromoGroups', {
                noCancel: false,
                fromFilters: true
            })
            this.$store.dispatch('countPromoGroupsTabs')
        },
        async changeTab() {
            this.$store.dispatch('setPromotionsDefaultPerPage')
            this.setDynamicPromoFilters()
            if (!this.isLotteryUser) {
                await this.$store.dispatch('resetPromotions')
                this.$store.dispatch('loadPromoGroups')
                this.$store.dispatch('setPromoGroupsPagination', { page: 1 })
            }
            if (this.isNewPromos) {
                this.$store.dispatch('setFilter', {
                    moduleName: 'promotions',
                    filter: 'id',
                    value: null
                })
            }
        },
        exportPromotions() {
            if (!this.isLotteryUser) {
                this.$store.dispatch('openModal', {
                    component: 'ModalExportFiles'
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.header-buttons {
    @media (max-width: 1420px) {
        flex-direction: column;
        margin-bottom: 1rem;
    }
}
</style>
